module.exports = __webpack_public_path__ + "static/media/strength-class-1.10f6c9b9.jpeg";